import {DetailsTabContentWrapper} from '@/features/projects/components/details-tab-content-wrapper/DetailsTabContentWrapper'
import {useTranslation} from '@/translations/i18n'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended, ProjectNotesType} from '@/features/projects/types'
import {Helmet} from 'react-helmet'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AdministrativeActivitiesSection} from '@/features/projects/components/administrative-activities-section/AdministrativeActivitiesSection'
import {OperationalNotesSection} from '@/features/projects/components/operational-notes-section/OperationalNotesSection'
import {useGetProjectNotes} from '@/features/projects/queries/useGetProjectNotes'
import {useMemo, useState} from 'react'
import {ActivitiesSection} from '@/features/projects/components/activities-section/ActivitiesSection'

export type CardInEditModeType = 'AdministrativeActivitiesSection' | 'OperationalNotesSection' | null

export const ProjectDetailsNotes = () => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {data: projectNotes, isLoading} = useGetProjectNotes({urlParams: {projectId: project.id}})
    const [cardInEditMode, setCardInEditMode] = useState<CardInEditModeType>(null)

    const administrativeActivity = useMemo(() => {
        return projectNotes?.find(note => note.type === ProjectNotesType.enum.administrative_activities)
    }, [projectNotes])

    const operationalNotes = useMemo(() => {
        return projectNotes?.find(note => note.type === ProjectNotesType.enum.operational_notes)
    }, [projectNotes])

    const activities = useMemo(() => {
        return projectNotes?.find(note => note.type === ProjectNotesType.enum.activity)
    }, [projectNotes])

    return (
        <DetailsTabContentWrapper>
            <Helmet title={t('commons:fullname_details_meta_title', {fullName: project.patient.fullName})} />
            <Flexbox direction="column" gap={4} fullWidth align="stretch">
                {activities && <ActivitiesSection activities={activities} />}

                <AdministrativeActivitiesSection
                    cardInEditMode={cardInEditMode}
                    setCardInEditMode={setCardInEditMode}
                    administrativeActivity={administrativeActivity}
                    isLoading={isLoading}
                />
                <OperationalNotesSection
                    cardInEditMode={cardInEditMode}
                    setCardInEditMode={setCardInEditMode}
                    operationalNotes={operationalNotes}
                    isLoading={isLoading}
                />
            </Flexbox>
        </DetailsTabContentWrapper>
    )
}
